// LabelWorkflowTable.tsx
import React from 'react';
import { useProjectDetailsContext } from '../contexts/ProjectDetailsContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import Avatar from './Avatar';
import { useUser } from '@clerk/clerk-react';
import LabelWorkflowTableRow from './LabelWorflowTableRow';

// RoundedArrow component extracted from the original component
const RoundedArrow: React.FC = () => {
    return (
        <svg viewBox="0 0 120 100" preserveAspectRatio="none" className="arrow">
            <path
                d="M60,0 
        L82,0 
        A12,12 0 0,1 94,8 
        L112,42 
        A12,12 0 0,1 112,58
        L94,92       
        A12,12 0 0,1 82,100
        L60,100"
            />
        </svg>
    );
};

const LabelWorkflowTable: React.FC = () => {
    const {
        state: { labels, userDetailsMapping, labelThumbnailUrls, project },
    } = useProjectDetailsContext();

    const { user } = useUser();

    if (!project) return null;

    const userCanReview = (reviewerId: string) => {
        if (user && user.id === reviewerId) {
            return true;
        }
        return false;
    };

    return (
        <>
            <table className="label-table">
                <thead>
                    <tr>
                        <th className="empty-column"></th>
                        <th className="review-column">
                            <div className="header-card ai-review">
                                <div className="header-content">
                                    <p>AI Review</p>
                                </div>
                                <RoundedArrow />
                            </div>
                        </th>
                        {project.workflow.stages.map((stage, i) => {
                            return (
                                <th className="review-column" key={i}>
                                    <div className="header-card">
                                        <div className="header-content">
                                            <p>{stage.name}</p>
                                            <div className="botton-container">
                                                <Avatar
                                                    userDetails={
                                                        userDetailsMapping[
                                                            stage.reviewer
                                                        ]
                                                    }
                                                    height={22}
                                                />
                                                <FontAwesomeIcon
                                                    icon={faEllipsisV}
                                                />
                                            </div>
                                        </div>
                                        <RoundedArrow />
                                    </div>
                                </th>
                            );
                        })}
                    </tr>
                </thead>
                <tbody>
                    {labels.map((label) => (
                        <LabelWorkflowTableRow
                            key={label.id}
                            label={label}
                            labelThumbnailUrl={labelThumbnailUrls[label.id]}
                            userDetailsMapping={userDetailsMapping}
                            project={project}
                            userCanReview={userCanReview}
                        />
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default LabelWorkflowTable;
